module.exports = __webpack_public_path__ + "media/music/drumkit_4-3de9e81a.mp3";